import { render, staticRenderFns } from "./a-histogram.vue?vue&type=template&id=3d7b3ea1"
import script from "./a-histogram.vue?vue&type=script&lang=js"
export * from "./a-histogram.vue?vue&type=script&lang=js"
import style0 from "./a-histogram.vue?vue&type=style&index=0&id=3d7b3ea1&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports